//@ts-nocheck
import { setfreeTextFareRules,setstructuredFareRules } from '../ActionCreator/penaltiesTab';
import { Penalties, TripType } from '../Utils/Constant';
import { env } from '../appConfig'

// Api Function for Text Fare Rules

async function getApiResponsetextFareRules(url, requestOptions) {

    const response = await fetch(url, requestOptions);

    if (!response.ok) {
        return null;
    } else {
         let data = await response;
         if(data) {

             data = data.json();
             return data;
         } 

     
        return data;
    }

}

// Api Function for Structured Fare Rules

async function getApiResponsestrtextFareRules(url, requestOptions,flag) {
    // CURRENTLY THIS API NOT IN SCOPE OF APPLICATION, PASSING FALSE VALUE FOR NOT CALLING API
     if(!flag) return 
    const response = await fetch(url, requestOptions);

    if (!response.ok) {
        return null;
    } else {
        const data = await response.json();
        return data;
    }
 
}




export const getPenaltiesData = (fareId,side) => {


    return async (dispatch, getState) => {
        let group = [];
        let textFareRule=[];
        const tokenData = getState().initToken;
        const token = tokenData && tokenData.token && tokenData.token.token;
        const corrId = getState().searchForm.uuid;
        const tripTypeValue = getState().searchForm.tripType;
        const flightType = getState().searchForm.flightType;
        const penaltiesStructureData = getState().Penalaties.structuredFareRules;
        penaltiesStructureData && group.push(...penaltiesStructureData);
        const penaltiesTextFareData = getState().Penalaties.freeTextFareRules;
        penaltiesTextFareData && textFareRule.push(...penaltiesTextFareData);
        //  const token = "a119cdf6-7aea-47dc-b4df-fe740e467857";
        
        // Api For FareRules
       
        let url = env.REACT_APP_API_BASE_URL+`/getFareRules/freeText?token=${token}`

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-type": "application/json; charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                
                "Access-Control-Allow-Credentials" : true,
                correlationId: corrId,
                flightType:flightType               

            },
            body:
                JSON.stringify(
                    {
                       fareId: fareId
                    //    flightId: flightId
                    })
        }
         
       
        // Api For Structured Fare Rules

        let url1 = env.REACT_APP_API_BASE_URL+`/getFareRules/structured?token=${token}`


        const requestOptions1 = {
            method: "POST",
            headers: {
                "Content-type": "application/json; charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                
                "Access-Control-Allow-Credentials" : true,
                correlationId: corrId,
                flightType:flightType

            },
            body:
                JSON.stringify(
                    {
                       fareId:fareId,
                    })
        }
        const penaltiesResultstructuredtextFareRules = await getApiResponsestrtextFareRules(url1,requestOptions1,false);
        
        // if(penaltiesResultstructuredtextFareRules && penaltiesResultstructuredtextFareRules.error){
        //     const result = {
        //         [fareId]: Penalties.FARE_RULES_ERROR
        //       }
        //       group.push(result);
        //     dispatch(setstructuredFareRules(group));
        // } else {
        //     const result = {
        //         [fareId]: penaltiesResultstructuredtextFareRules.fareRules
        //       }
        //       group.push(result);
        //     dispatch(setstructuredFareRules(group));
        // }
     


        const penaltiesResultFareRules = await getApiResponsetextFareRules(url, requestOptions);

        
         if(penaltiesResultFareRules && penaltiesResultFareRules.error){
            const result = {
                [fareId]: Penalties.STR_FARE_RULES_ERROR
              }
              textFareRule.push(result);
            dispatch(setfreeTextFareRules(textFareRule));
         } else if( penaltiesResultFareRules && penaltiesResultFareRules.segments){
            if(tripTypeValue === TripType.MULTICITY){
                const result = {
                    [fareId]: penaltiesResultFareRules && penaltiesResultFareRules.segments
                  }
                textFareRule.push(result);
                dispatch(setfreeTextFareRules(textFareRule));
            }
            if(tripTypeValue === TripType.ONEWAY){    
                    
                const result = {
                    [fareId]: penaltiesResultFareRules && penaltiesResultFareRules.segments && penaltiesResultFareRules.segments[0]
                }
                textFareRule.push(result);                 
                dispatch(setfreeTextFareRules(textFareRule));
            }            

            if(tripTypeValue === TripType.ROUNDTRIP || tripTypeValue === TripType.OPENJAW){            
                const result = {
                    [fareId]: penaltiesResultFareRules
                  }
                textFareRule.push(result);                 
               dispatch(setfreeTextFareRules(textFareRule));
              }             
            
         }
       
       
    }
}